import { BasicCouponFragment } from 'drycut-graphql';

type Props = {
  coupon: BasicCouponFragment | undefined;
  service: { price: number; kidsPrice?: number | null | undefined } | undefined | null;
  kidCustomer: boolean;
};

export function computeBookingPrice({ service, coupon, kidCustomer = false }: Props): number {
  if (coupon) {
    return coupon.price;
  }

  if (kidCustomer && service?.kidsPrice) {
    return service.kidsPrice;
  }

  return service?.price || 0;
}
